import map from "lodash/fp/map";
class Controller {
  constructor($stateParams, $injector, Lists) {
    "ngInject";

    this.$stateParams = $stateParams;

    this.ActionLists = $injector.get("ActionLists");
    this.City = $injector.get("City");
    this.Events = $injector.get("Events");
    this.Messages = $injector.get("Messages");
    this.Promotion = $injector.get("Promotion");
    this.UserPromotions = $injector.get("Userpromotion");
    this.sections = $injector.get("Sections").settingsSections;
    this.PromotionTransforms = $injector.get("PromotionTransforms");
    this.onUpdate = this.Events.getUpdateEvent("promotion");
    this.onUpdateDetail = this.Events.getUpdateEvent("promotionUpdateDetail");
    this.onPromotionValueEdit = this.Events.getUpdateEvent(
      "promotionValueEdit"
    );

    this.userPromotionParams = {
      promotion: this.$stateParams.id,
      isCityRequired: false,
    };
    this.userPromotionFields = this.PromotionTransforms.userPromotionFields;
    this.promotionResourceId = this.$stateParams.id;
    this.userPromotionResourceActions = this.ActionLists.all.userPromotionsActions;
    this.addItemEvent = this.Events.getAddEvent("userpromotions");
    this.addOptions = this.PromotionTransforms.addOptions;
    this.showNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.Lists = Lists.all;
    this.segmentList = this.Lists.promoSegments;
    this.renewalValues = this.Lists.renewalValues;
    this.promotionCity = null;
  }
  $onInit() {
    this.newItemModel = {};
    const item = this.PromotionTransforms.item;
    const mapKeyId = (item) => item._id || item.name._id;
    const errorEvent = this.Events.eventsType.onShowErrorNotification;
    const onUpdate = (item) => {
      const updatedItem = {};
      updatedItem[item.key] =
        typeof item.value !== "undefined"
          ? item.value
          : item.name
          ? item.name._id
          : null;
      this.Promotion.update(this.$stateParams.id, updatedItem).$promise.then(
        () => {
          this.promotion[item.key].isDisabled = true;
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("promotion", item.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.getSystemCategories();

    const onUpdateDetail = (options) => {
      const updatedItem = {};
      updatedItem[options.name] = map(mapKeyId)(options[options.name]);
      this.Promotion.update(this.$stateParams.id, updatedItem).$promise.then(
        () => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("promotion", options.key)
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };
    const onPromotionValueUpdate = (options) => {
      this.Promotion.update(this.$stateParams.id, options).$promise.then(
        () => {
          this.Events.emit(
            this.showNotificationEvent,
            this.Messages.updateMessage("promotion", "value")
          );
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };

    this.Promotion.get(this.$stateParams.id).$promise.then((response) => {
      this.promotion = this.PromotionTransforms.justify(response);
      this.promotionCity = this.promotion.cities[0];
      this.personalized = this.promotion.personalized.value;
    });
    const onAdd = (options) => {
      this.UserPromotions.post({
        users: options.users,
        promotion: this.$stateParams.id,
      }).$promise.then(
        (response) => {
          if (options.users.length > 1) {
            this.Events.emit(this.showNotificationEvent, {
              message: "Users Added Successfully",
            });
          } else {
            this.Events.emit(this.showNotificationEvent, {
              message: "User Added Successfully",
            });
          }
          this.newItemModel = {};
          this.addOptions.fields = this.ResetFields.reset(
            this.addOptions.fields
          );
          if (item.state) {
            this.$state.transitionTo(item.state, { id: response._id });
          }
        },
        (response) => this.Events.emit(errorEvent, response.data)
      );
    };
    this.Events.on(this.onUpdate, onUpdate);
    this.Events.on(this.onUpdateDetail, onUpdateDetail);
    this.Events.on(this.onPromotionValueEdit, onPromotionValueUpdate);
    if (this.addItemEvent) this.Events.on(this.addItemEvent, onAdd);
  }
  getSystemCategories() {
    this.systemCategories = [];
    this.City.getRideCategory().$promise.then((response) => {
      if (response.hits) {
        this.systemCategories = response.hits.map(
          ({ _id: name, _source: category }) => ({
            name,
            title: `${category.ride_type} ${category.service_type}`,
          })
        );
      }
    });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/promotion/promotion.controller.js